import Vue from 'vue'
import {OK} from 'http-status-codes'
import Constants from 'src/utilities/constants'
import {make} from 'vuex-pathify'
import {searchFieldsHaveValues,} from 'src/utilities/utils'
import {resetResults} from '@/utilities/vuex2'
import {ptracGetEntities} from '@/utilities/ptracApi'
import {createAndDownloadWorksheet} from '@/utilities/excel'
import {idaSearch} from '@/utilities/idaSearchHelper'

const initialState = {
  autocompleteResultsClient: [],
  autocompleteResultsBuilder: [],
  autocompleteResultsCommunity: [],
  autocompleteResultsStreet: [],
  query: {
    idaId: null,
    idaClientName: null,
    idaBuilderName: null,
    idaSubdivisionName: null,
    idaCity: null,
    idaStreetName: null,
    streetNumber: null,
    state: 'TX',
    idaInspectionType: null,
    idaScheduler: null,
    idaInspector: null,
    inspectionResult: [],
    requestedInspectionDate: null,
    dateScheduled: null,
    actualInspectionDate: null,
    invoiceNumber: null,
    price: null
  },
  results: [],
  resultsExcel: [],
  loadingProgress: {
    loaded: 0,
    total: 0,
    percent: 0,
    message: ''
  }
}

let state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
const mutations = make.mutations(state)

getters.results = (state) => {
  return state.results === undefined ? [] : state.results
}

getters.searchFieldsHaveValues = (state) => {
  const searchFields = [
    'name',
    'status',
    'search',
    'ownerId',
    'idaId',
    'idaClientName',
    'idaBuilderName',
    'idaSubdivisionName',
    'idaCity',
    'idaStreetName',
    'streetNumber',
    'state',
    'idaInspectionType',
    'inspectionResult',
    'idaScheduler',
    'idaInspector',
    'requestedInspectionDate',
    'dateScheduled',
    'actualInspectionDate',
    'invoiceNumber',
    'price'
  ]

  return searchFieldsHaveValues(state.query, searchFields)
}

mutations.results = (state, results) => {
  state.results = results
}

mutations.resultsExcel = (state, results) => {
  state.resultsExcel = results
}

mutations.resetResults = resetResults

mutations.resetQuery = (state) => {
  for (let f in state.query) {
    Vue.set(state.query, f, initialState.query[f])
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchClientByNameStartsWith({commit}, payload) {
      const response = await ptracGetEntities('ida-clients/search/findByNameStartsWithIgnoreCaseOrderByNameAsc?name=' + payload.name)

      if (OK === response.status) {
        commit('autocompleteResultsClient', response.data)
      }

      return response
    },
    async fetchBuilderByNameStartsWith({commit}, payload) {
      const response = await ptracGetEntities('ida-builders/search/findByNameStartsWithIgnoreCaseOrderByNameAsc?name=' + payload.name)

      if (OK === response.status) {
        commit('autocompleteResultsBuilder', response.data)
      }

      return response
    },
    async fetchSubdivisionByNameStartsWith({commit}, payload) {
      const response = await ptracGetEntities('ida-subdivisions/search/findByNameStartsWithIgnoreCaseOrderByNameAsc?name=' + payload.name)

      if (OK === response.status) {
        commit('autocompleteResultsCommunity', response.data)
      }

      return response
    },
    async fetchStreetByNameStartsWith({commit}, payload) {
      const response = await ptracGetEntities('ida-streets/search/findByNameStartsWithIgnoreCaseOrderByNameAsc?name=' + payload.name)

      if (OK === response.status) {
        commit('autocompleteResultsStreet', response.data)
      }

      return response
    },
    async fetchSearchResults({state, commit, rootGetters}) {
      const esCreds = rootGetters['config/byName'](Constants.CONFIGS.ELASTICSEARCH_UN_PW)
      const response = await idaSearch(esCreds, state.query, 0)

      if (response.hits.hits.length > 0) {
        const total = response.hits.hits.length
        state.loadingProgress.total = total
        state.loadingProgress.message = 'Rendering table, almost there ...'
        state.loadingProgress.loaded = total
        state.loadingProgress.percent = 100
        commit('results', response.hits.hits)
      }

      return response
    },
    resultsToExcel({state, rootState}) {
      const fileName = 'ida-search-results.xlsx'
      const tabName = 'IDA Archive'
      const header = [
        {
          header: 'Client Name',
          key: 'clientName',
          width: 20
        }, {
          header: 'Builder Name',
          key: 'builderName',
          width: 20
        }, {
          header: 'Subdivision Name',
          key: 'subdivisionName',
          width: 20
        }, {
          header: 'Street Number',
          key: 'streetNumber',
          width: 15
        },{
          header: 'Street Name',
          key: 'streetName',
          width: 20
        }, {
          header: 'City',
          key: 'city',
          width: 15
        }, {
          header: 'State',
          key: 'state',
          width: 10
        }, {
          header: 'Inspection Type',
          key: 'inspectionType',
          width: 40
        }, {
          header: 'Scheduled By',
          key: 'scheduledBy',
          width: 25
        }, {
          header: 'Date Scheduled',
          key: 'dateScheduled',
          width: 25
        }, {
          header: 'Actual Inspection Date',
          key: 'actualInspectionDate',
          width: 25
        }, {
          header: 'Inspected By',
          key: 'inspectedBy',
          width: 25
        }, {
          header: 'Inspection Result',
          key: 'inspectionResult',
          width: 25
        }, {
          header: 'ID',
          key: 'idaId',
          width: 15
        }]
      const searchResults = _.map(state.results, '_source')

      const rows = []
      searchResults.forEach((result) => {
        rows.push(
          {
            clientName: result.clientName,
            builderName: result.builderName,
            subdivisionName: result.subdivisionName,
            streetNumber: result.streetNumber,
            streetName: result.streetName,
            city: result.city,
            state: result.state,
            inspectionType: result.inspectionType,
            scheduledBy: result.scheduledBy,
            dateScheduled: new Date(result.dateScheduled),
            inspectedBy: result.inspectedBy,
            inspectionResult: result.inspectionResult,
            idaId: result.idaId,
          }
        )
      })

      const user = rootState.security.user

      createAndDownloadWorksheet(fileName, tabName, header, rows, user)
    }
  }
}
